module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-actions"
  }, [(_vm.activeNote) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("wordCount")(_vm.activeNote.body)) + " words,\n      " + _vm._s(_vm._f("charCount")(_vm.activeNote.body)) + " chars\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.randomQuote()) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "foot__right"
  }, [(_vm.activeNote && _vm.user) ? [_c('button', {
    staticClass: "button-icon share",
    on: {
      "click": _vm.onShareNote
    }
  })] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button-icon theme",
    on: {
      "click": _vm.onUpdateTheme
    }
  }), _vm._v(" "), _c('dropdown')], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ee015b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Foot/FootActions.vue
// module id = 2118
// module chunks = 0